import React from "react";
import { Icon, Input, SemanticICONS } from "semantic-ui-react";

interface InputGroupProps {
  name?: string;
  placeholder?: string;
  value?: string;
  error?: any;
  icon: SemanticICONS;
  type?: string;
  onChange?: any;
}
const InputGroup: React.FC<InputGroupProps> = ({
  name,
  error,
  value,
  placeholder,
  type,
  icon,
  onChange,
}) => {
  return (
    <div className="input-group mb-3">
      <Input
        icon={<Icon name={icon} inverted circular link />}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        type={type}
        name={name}
      />
      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
};

export default InputGroup;
